import React, { useEffect, useState } from 'react'
import styles from './TitleDisplay.module.scss'
import NomadIcon from 'assets/icons/titles/NomadIcon'
import TravelerIcon from 'assets/icons/titles/TravelerIcon'
import ExplorerIcon from 'assets/icons/titles/ExplorerIcon'
import MasterIcon from 'assets/icons/titles/MasterIcon'
import LegendIcon from 'assets/icons/titles/LegendIcon'

const titleIcons = {
  'Кочевник (Новичок)': NomadIcon,
  'Кочевник': NomadIcon,
  'Путешественник': TravelerIcon,
  'Исследователь': ExplorerIcon,
  'Мастер': MasterIcon,
  'Легенда': LegendIcon
}

export default function TitleDisplay({ user, nextTitle, allTitles = [], loading = false }) {
  const [progress, setProgress] = useState(0)
  
  useEffect(() => {
    if (user && nextTitle) {
      const currentPoints = user.activity_points || 0
      const requiredPoints = nextTitle.min_activity
      const calculatedProgress = Math.min((currentPoints / requiredPoints) * 100, 100)
      
      // Анимация прогресса
      setTimeout(() => setProgress(calculatedProgress), 100)
    }
  }, [user, nextTitle])
  
  const getCurrentTitleIcon = () => {
    if (!user?.title) return NomadIcon
    const IconComponent = titleIcons[user.title.name] || NomadIcon
    return IconComponent
  }
  
  const getNextTitleIcon = () => {
    if (!nextTitle) return null
    const IconComponent = titleIcons[nextTitle.name] || LegendIcon
    return IconComponent
  }
  
  const CurrentIcon = getCurrentTitleIcon()
  const NextIcon = getNextTitleIcon()
  
  return (
    <div className={styles.titleDisplay}>
      {loading ? (
        <div className={styles.loading}>
          <div className={styles.loadingSpinner}></div>
          <p>Загрузка титулов...</p>
        </div>
      ) : (
        <>
          <div className={styles.currentTitle}>
            <div className={styles.titleHeader}>
              <div className={styles.iconWrapper}>
                <CurrentIcon size={64} className={styles.titleIcon} />
                <div className={styles.glow}></div>
              </div>
              <div className={styles.titleInfo}>
                <h3 className={styles.titleName}>{user?.title?.name || 'Без титула'}</h3>
                <p className={styles.titleDescription}>{user?.title?.description || ''}</p>
                <div className={styles.benefits}>
                  <div className={styles.benefit}>
                    <span className={styles.benefitLabel}>Кешбэк:</span>
                    <span className={styles.benefitValue}>{user?.title?.cashback_percent || 0}%</span>
                  </div>
                  <div className={styles.benefit}>
                    <span className={styles.benefitLabel}>Активность:</span>
                    <span className={styles.benefitValue}>{user?.activity_points || 0}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {nextTitle && (
            <div className={styles.progressSection}>
              <div className={styles.progressHeader}>
                <span className={styles.progressLabel}>До следующего титула</span>
                <span className={styles.progressPoints}>
                  {user?.activity_points || 0} / {nextTitle.min_activity}
                </span>
              </div>
              
              <div className={styles.progressBar}>
                <div 
                  className={styles.progressFill}
                  style={{ width: `${progress}%` }}
                >
                  <div className={styles.progressGlow}></div>
                </div>
                <div className={styles.progressPercentage}>{Math.round(progress)}%</div>
              </div>
              
              <div className={styles.nextTitle}>
                <div className={styles.nextIconWrapper}>
                  {NextIcon && <NextIcon size={48} className={styles.nextIcon} />}
                </div>
                <div className={styles.nextTitleInfo}>
                  <h4 className={styles.nextTitleName}>{nextTitle.name}</h4>
                  <p className={styles.nextTitleDescription}>{nextTitle.description}</p>
                  <div className={styles.nextBenefits}>
                    <span className={styles.nextBenefit}>
                      Кешбэк: {nextTitle.cashback_percent}%
                    </span>
                    <span className={styles.pointsNeeded}>
                      Нужно: {nextTitle.min_activity - (user?.activity_points || 0)} очков
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
          
          {allTitles.length > 0 && (
            <div className={styles.allTitles}>
              <h4 className={styles.allTitlesHeader}>Все титулы</h4>
              <div className={styles.titlesGrid}>
                {allTitles.map((title, index) => {
                  const TitleIcon = titleIcons[title.name] || NomadIcon
                  const isUnlocked = (user?.activity_points || 0) >= title.min_activity
                  const isCurrent = user?.title?.id === title.id
                  
                  return (
                    <div 
                      key={title.id} 
                      className={`${styles.titleCard} ${isUnlocked ? styles.unlocked : styles.locked} ${isCurrent ? styles.current : ''}`}
                    >
                      <div className={styles.cardIconWrapper}>
                        <TitleIcon size={40} className={styles.cardIcon} />
                        {isCurrent && <div className={styles.currentBadge}>Текущий</div>}
                        {!isUnlocked && <div className={styles.lockOverlay}>🔒</div>}
                      </div>
                      <div className={styles.cardInfo}>
                        <h5 className={styles.cardTitle}>{title.name}</h5>
                        <p className={styles.cardCashback}>Кешбэк: {title.cashback_percent}%</p>
                        <p className={styles.cardRequirement}>
                          {title.min_activity === 0 ? 'Начальный' : `от ${title.min_activity} очков`}
                        </p>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  )
}
